import React from "react";
import { ShareButton } from "../../../MVVM/Components/Button/Share";
import { RiShareForwardFill } from "react-icons/ri";
import styled from "styled-components";

const StyledShare = styled(RiShareForwardFill)`
  position: relative;
  top: 4px;
`;

let StyledShareButton = styled(ShareButton)`
  ${(props) => (props.hideOnDesktop ? "display:none" : null)};

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    ${(props) => (props.hideOnDesktop ? "display:block" : null)};
  }
`;

export default function ClipShare({
  size,
  children,
  classification,
  mr,
  clip,
  onClick,
  hideOnDesktop,
  ...props
}) {
  classification = classification ? classification : "secondary";

  return (
    <>
      <StyledShareButton
        hideOnDesktop={hideOnDesktop}
        size={size}
        classification={classification}
        flex={true}
        justifyContent="flex-start"
        mr={mr}
        onClick={() => {
          onClick();
        }}
        {...props}
      >
        <StyledShare size={20} />
        {children}
      </StyledShareButton>
    </>
  );
}
